// Mirrors apps/mobile/src/utils/casing.ts — used to convert snake_case
// JSON keys from some backend endpoints (notifications) to camelCase.

export function snakeToCamel(s: string): string {
  return s.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase())
}

export function camelKeys<T extends Record<string, unknown>>(obj: T): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [snakeToCamel(k), v]),
  )
}
